module.exports = __webpack_public_path__ + "img/deleted.2f0a23c7.svg";